import React, { useState, useEffect } from 'react'
import { BsQuestionCircle } from "react-icons/bs";
import { NavLink, useNavigate } from "react-router-dom";
import loader from "../../../../assets/images/menu-icon/loader.gif";
import { Dispatch } from "redux";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from '../../../../config/Store';
import { setAdminAgreementTab } from '../../../../reducers/AuthReducer';
import WebService, { BASE_URL } from '../../../../utility/WebService';
import Loader from '../../../../components/Loader/Loader';
import { AGREEMENT_TAB, setDataInRedux } from '../../../../actions/CommonAction';
import Pagination from '../../../../components/pagination/Pagination';
import { TbDownload, TbUpload } from 'react-icons/tb';
import SignedAgreement from './SignedAgreement';
import CompletedAgreement from './CompletedAgreement';
import SucessModal from '../../../../components/SucessModal/Sucess';
import WarningModal from '../../../../components/Warning/Warning';
import HelperService from '../../../../utility/HelperService';
import ExpiredContact from './ExpiredContact';
import BackComponent from '../../../../components/BackArrow';

const Agreement = () => {
    const user_data = JSON.parse(localStorage.getItem("user_Detail") || "{}");
    const getTab = localStorage.getItem("goToTab");
    const [openTab, setOpenTab] = React.useState(user_data.is_person == 'Employee' ? 4 : 1);
    let history = useNavigate();
    const [totalCount, setTotalCount] = useState(0);
    const [agreement, setAgreement] = useState<any[]>([]);
    const [currentPage, setCurrentPage] = useState(1);
    const tab: any = useSelector<RootState, setAdminAgreementTab>((state) => state.adminAgreementTab);
    const dispatch: Dispatch<any> = useDispatch();
    const [sucessMessage, setSucessMessage] = useState<any>()
    const [isShowSucessModal, setShowSucessModal] = useState(false);
    const [warningMessage, setWarningMessage] = useState<any>()
    const [isShowWarningModal, setShowWarningModal] = useState(false);
    const [showLoader, setShowLoader] = useState(false);
    const [searchText, setSearchText] = useState('');
    const [isLoading, setLoading] = useState(false);
    const [res, setRes] = useState<any>({});

    useEffect(() => {
        const getTab = localStorage.getItem("goToTab");
        if(getTab){
            getTab == "SIGNED" && setOpenTab(2);
            getTab == "PENDING" && setOpenTab(1);
            getTab == "COMPLETED" && setOpenTab(3);
        }
        if (tab.tabName) {
            setOpenTab(tab.tabName)
        }
        getList(1);
        tabsCount();
    }, []);

    const getList = (page: Number) => {
        setShowLoader(true);
        WebService.getAPI({
            action: `${user_data.is_person == 'Employee' ? `/v2/ClientAgreements/GetAgreementList` : `/v2/ClientAgreements/GetClientAgreementList`}?page=${page}&status=PENDING&keyword=${searchText}`,
            body: null
        })
            .then((res: any) => {
                setAgreement(res.list)
                setTotalCount(res.total_count)
                setShowLoader(false);
            })
            .catch(() => {
                setShowLoader(false);
            });
    };

    const tabsCount = () =>{
        WebService.getAPI({
            action: `/v2/ClientAgreements/GetTabsCount?person=${user_data.is_person == "Employee" ? "Employee" : "Client"}`,
            body: null
        })
            .then((res: any) => {
               setRes(res);
            })
            .catch(() => {
            });

    }

    const download = (id: any) => {
        setShowLoader(true);
        window.open(`${BASE_URL}/v2/ClientAgreements/DisplayDocument?id=${id}`)
        setShowLoader(false)
    }
    const onClickESign = (id: any) => {
        var obj: any = {}
        obj.agreement_id = id
        WebService.postAPI({
            action: `/v2/ClientAgreements/SignAadharEsign`,
            body: obj
        })
            .then((res: any) => {
                console.log(res);
                setShowLoader(true);
                window.open(`${res.url}`)
                setOpenTab(2)
                setShowLoader(false)
            })
            .catch(() => {
                setShowLoader(false);
            });
    }

    const sucessCloseModal = () => {
        setShowSucessModal(false)
        setLoading(false);
    }

    const warningCloseModal = () => {
        setShowWarningModal(false)
        setLoading(false);
    };

    return (
        <>
            <SucessModal
                show={isShowSucessModal}
                isClose={sucessCloseModal}
                message={sucessMessage}
            />
            <WarningModal
                show={isShowWarningModal}
                isClose={warningCloseModal}
                message={warningMessage}
            />
            <Loader show={showLoader} />
            <div className="page-content-wraper">
                <div className="grid grid-cols-2 gap-4 mb-4">
                    <div>
                        <div><BackComponent title={'Agreement'} /> </div>
                    </div>
                    <div className="text-right">
                        <button type="button" className="btn bg-white px-3 py-1 rounded-md hover:shadow-xl  shadow-sm mr-3" title="Help">
                            <BsQuestionCircle size={20} className="inline mr-1" /> Help
                        </button>
                        {/* {openTab == 3 && */}
                            <>
                                <button type="button" className="btn bg-white px-3 py-1 rounded-md hover:shadow-xl  shadow-sm mr-3" title="Archive" onClick={() => history(`/admin/mis-report/archived-agreement`)}>
                                    <svg className="icon inline mr-2 inline" width={20} height={20}>
                                        <use xlinkHref="/images/svg-sprint/common-icon-sprint.svg#archivedIcon"></use>
                                    </svg> Expired Agreements
                                </button>
                            </>
                        {/* } */}
                        {user_data.is_person == 'Employee' && openTab == 1 &&
                            <>
                                <NavLink to="/admin/mis-report/add-agreement" className="btn btn-brand btn-sm">+ Add</NavLink>
                            </>
                        }
                    </div>
                </div>
                <div className="mb-4 flex items-center justify-between">
                    <ul className="flex list-none flex-wrap pt-3  tab-style-1 mb-3 w-[max-content] border-white border-b-[3px] relative" role="tablist">
                        {user_data.is_person == 'Employee' &&
                            <li className=" mr-2 last:mr-0 tab-nav">
                                <a
                                    className={"tab-nav-link " + (openTab === 4 ? "active" : "")}
                                    onClick={e => {
                                        e.preventDefault();
                                        dispatch(setDataInRedux({ type: AGREEMENT_TAB, value: 4 }));
                                        localStorage.setItem('openTab', "4")
                                        setOpenTab(4);
                                        getList(1)

                                    }}
                                    data-toggle="tab"
                                    href="#link4"
                                    role="tablist"
                                    style={{ paddingRight: "25px" }}
                                >
                                    No Agreement
                                    <span className=" bg-brand inline-flex text-white text-xs justify-center items-center w-5 h-5 rounded-full ml-1 absolute ">
                                    {res.no_agreement}
                                    </span>
                                </a>
                            </li>
                        }
                        <li className=" mr-2 last:mr-0 tab-nav">
                            <a
                                className={"tab-nav-link " + (openTab === 1 ? "active" : "")}
                                onClick={e => {
                                    e.preventDefault();
                                    dispatch(setDataInRedux({ type: AGREEMENT_TAB, value: 1 }));
                                    localStorage.setItem('openTab', "1")
                                    setOpenTab(1);
                                    getList(1)

                                }}
                                data-toggle="tab"
                                href="#link1"
                                role="tablist"
                                style={{ paddingRight: "25px" }}
                            >
                                Pending
                                <span className=" bg-brand inline-flex text-white text-xs justify-center items-center w-5 h-5 rounded-full ml-1 absolute ">
                                {res.pending}
                                </span>
                            </a>
                        </li>
                        <li className=" mr-2 last:mr-0 tab-nav">
                            <a
                                className={"tab-nav-link " + (openTab === 2 ? "active" : "")}
                                onClick={e => {
                                    e.preventDefault();
                                    dispatch(setDataInRedux({ type: AGREEMENT_TAB, value: 2 }));
                                    localStorage.setItem('openTab', "2")
                                    setOpenTab(2);
                                }}
                                data-toggle="tab"
                                href="#link2"
                                role="tablist"
                                style={{ paddingRight: "25px" }}
                            >
                                Signed
                                <span className=" bg-brand inline-flex text-white text-xs justify-center items-center w-5 h-5 rounded-full ml-1 absolute ">
                                {res.signed}
                                </span>
                            </a>
                        </li>
                        <li className=" mr-2 last:mr-0 tab-nav">
                            <a className={"tab-nav-link " + (openTab === 3 ? "active" : "")}
                                onClick={e => {
                                    e.preventDefault();
                                    dispatch(setDataInRedux({ type: AGREEMENT_TAB, value: 3 }));
                                    localStorage.setItem('openTab', "3")
                                    setOpenTab(3);
                                }}
                                data-toggle="tab"
                                href="#link2"
                                role="tablist"
                                style={{ paddingRight: "25px" }}
                            >
                                Completed
                                <span className=" bg-brand inline-flex text-white text-xs justify-center items-center w-5 h-5 rounded-full ml-1 absolute ">
                                {res.completed}
                                </span>
                            </a>
                        </li>
                    </ul>
                </div>
                <div className="tab-content tab-space">
                    <div className={openTab === 1 ? "block" : "hidden"} id="link1">
                        <div className="table-card">
                            <div className=" grid grid-cols-12 filter-wrap mb-3">
                                <div className="flex col-span-3">
                                    <div className="w-full mr-3 ">
                                        <label className="sr-only">Search</label>
                                        <div className="relative w-64">
                                            <div className="pointer-events-none absolute inset-y-0 left-0 flex items-center pl-3">
                                                <svg className="h-5 w-5 text-gray-400" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
                                                    <path fill-rule="evenodd" d="M9 3.5a5.5 5.5 0 100 11 5.5 5.5 0 000-11zM2 9a7 7 0 1112.452 4.391l3.328 3.329a.75.75 0 11-1.06 1.06l-3.329-3.328A7 7 0 012 9z" clip-rule="evenodd" />
                                                </svg>
                                            </div>
                                            <input id="search" name="search" className="block w-full table-search-filter" placeholder="Search" type="search" value={searchText} onChange={(e) => setSearchText(e.target.value)} onKeyUp={(e) => {
                                                if (e.keyCode === 13) {
                                                    getList(0)
                                                }
                                            }} />
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <table className="table-style-list">
                                <thead>
                                    <tr>
                                        <th>Client Name</th>
                                        <th>Agreement Type</th>
                                        <th>Agreement Start Date</th>
                                        <th>Agreement End Date</th>
                                        <th>Date</th>
                                        <th className='text-center'>Action</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {
                                        agreement?.length > 0 && agreement.map((res) => {

                                            return (
                                                <tr className="5097 odd" role="row">
                                                    <td className="align-left">{res.client_name ? res.client_name : "-"}</td>
                                                    <td className="align-left">{res.agreement_type === 'AADHAR_E_SIGN' ? 'Aadhar E-Sign' :
                                                    res.agreement_type === 'E_SIGN' ? 'Wet Sign' :
                                                    res.agreement_type === 'SCANED_BY_BOTH' ? 'Physical' :
                                                    "-"}</td>
                                                    <td className="align-left">{res.start_date ? HelperService.getFormatedDateByDMY(res.start_date) : "-"}</td>
                                                    <td className="align-left">{res.end_date ? HelperService.getFormatedDateByDMY(res.end_date) : "Perpetual"}</td>
                                                    <td className="align-left">{res.created_at ? HelperService.getFormatedDateByDMY(res.created_at) : "-"}</td>
                                                    {user_data.is_person == 'Client' &&
                                                        <><td className='text-center block-ruby'>
                                                            {res.agreement_type == 'AADHAR_E_SIGN' &&
                                                                <button type="button" title="Upload Signed Document" className="btn btn-brand mr-3" onClick={() => onClickESign(res.id)}>
                                                                    Sign</button>
                                                            }
                                                            {res.agreement_type != 'AADHAR_E_SIGN' &&
                                                            <button type="button" title="Upload Signed Document" className="btn btn-brand mr-3" onClick={() => history(`/admin/mis-report/upload-agreement/${res.id}`)}>
                                                                    Sign</button>
                                                            }
                                                            <a href="javascript:void(0)" className="action-btn " title="Download">
                                                                <TbDownload size={20} className=" text-brand" onClick={() => download(res.id)} />
                                                            </a>
                                                        </td>

                                                        </>
                                                    }
                                                    {user_data.is_person == 'Employee' &&
                                                        <td className='text-center block-ruby' >

                                                            <a href="javascript:void(0)" className="action-btn" title="Download">
                                                                <TbDownload size={20} className="mr-3 text-brand" onClick={() => download(res.id)} />
                                                            </a>
                                                            <a onClick={() => history(`/admin/mis-report/edit-agreement/${res.client_id}/${res.id}`, {
                                                                state: {
                                                                    name: res.client_name
                                                                }
                                                            })} href="javascript:void(0)" className="action-btn" title="Edit">
                                                                <svg className="icon inline mr-2" width={18} height={18} >
                                                                    <use xlinkHref="/images/svg-sprint/common-icon-sprint.svg#edit"></use>
                                                                </svg>
                                                            </a>
                                                            {/* <a onClick={() => onDelete(res.id)}>
                                                                <svg className="icon inline cursor-pointer ml-3" width={20} height={20}>
                                                                    <use xlinkHref="/images/svg-sprint/common-icon-sprint.svg#delete"></use>
                                                                </svg>
                                                            </a> */}
                                                        </td>
                                                    }
                                                </tr>
                                            )
                                        })
                                    }
                                </tbody>
                            </table>
                            <div className=" grid ">
                                {
                                    agreement?.length == 0 && showLoader == false &&
                                    <div>
                                        <div className="error-message-table">No Records Found</div>
                                    </div>
                                }
                                {
                                    showLoader &&
                                    <div style={{ textAlign: "center", marginTop: "10%" }}>
                                        <img
                                            style={{ position: "relative" }}
                                            src={loader}
                                            alt="No loader found"
                                        />
                                        <div style={{ position: "relative", color: "white" }}>
                                            Loading...
                                        </div>
                                    </div>
                                }
                                {
                                    totalCount > 0 &&
                                    <div className="d-flex flex-row justify-content-between pb-3 align-items-center pagination-row">
                                        <div className="d-flex col-6 align-items-center">
                                            <Pagination
                                                className=" "
                                                changePage={(page: number) => {
                                                    setCurrentPage(page);
                                                    getList(page);
                                                }}
                                                totalItems={totalCount}
                                                changeCurrentPage={currentPage}
                                            />
                                        </div>
                                    </div>
                                }
                            </div>
                        </div>
                    </div>
                    {openTab == 2 && <SignedAgreement />}
                    {openTab == 3 && <CompletedAgreement />}
                    {openTab == 4 && <ExpiredContact />}

                </div>
            </div>
        </>
    );
};
export default Agreement;

